const enum UserTypeEnum {
  tenant = 'tenant',
  landlord = 'landlord',
}
type UserType = UserTypeEnum.tenant | UserTypeEnum.landlord;

enum AppRedirect {
  SIGNUP = 'SIGNUP',

  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',

  DASHBOARD_SUDO = 'DASHBOARD_SUDO',
  DASHBOARD_MYPAGE = 'DASHBOARD_MYPAGE', // for all landlord profiles
  DASHBOARD_LANDLORD = 'DASHBOARD_LANDLORD', // for a specific landlord profile
  DASHBOARD_RENTAL_OBJECT_CREATE = 'DASHBOARD_RENTAL_OBJECT_CREATE',
  DASHBOARD_LANDLORD_TENANCY_DETAILS = 'DASHBOARD_LANDLORD_TENANCY_DETAILS', // dashboard existing tenancy details
  DASHBOARD_LANDLORD_TENANCY_PAYMENTS_DETAILS = 'DASHBOARD_LANDLORD_TENANCY_PAYMENTS_DETAILS', // dashboard existing tenancy payment details
  RENTAL_OBJECT_CREATE = 'RENTAL_OBJECT_CREATE',
  CONTRACT_CREATE = 'CONTRACT_CREATE',
  CONTRACT_EDIT = 'CONTRACT_EDIT',
  CONTRACT_SIGN = 'CONTRACT_SIGN',
  CONTRACT_PREVIEW = 'CONTRACT_PREVIEW',

  TENANCY_TERMINATION = 'TENANCY_TERMINATION',

  INSPECTION_REPORT_CREATE = 'INSPECTION_REPORT_CREATE',
  INSPECTION_REPORT_PREVIEW = 'INSPECTION_REPORT_PREVIEW',
  INSPECTION_REPORT_EDIT = 'INSPECTION_REPORT_EDIT',
  INSPECTION_REPORT_SIGN = 'INSPECTION_REPORT_SIGN',

  AD_CREATE = 'AD_CREATE',
  AD_EDIT = 'AD_EDIT',

  DEPOSIT_ACCOUNT = 'DEPOSIT_ACCOUNT',
  DEPOSIT_ACCOUNT_SIGN = 'DEPOSIT_ACCOUNT_SIGN',

  LOCATION_REDIRECT = 'LOCATION_REDIRECT',

  CONTRACT_EXISTING_CREATE = 'CONTRACT_EXISTING_CREATE',

  BANKID_VERIFICATION = 'BANKID_VERIFICATION',

  PROSPECT_DETAILS = 'PROSPECT_DETAILS',
}

enum AppRedirectTargetActions {
  MYPAGE = 'mypage',
  CREATE_CONTRACT = 'createContract',
  CREATE_EXISTING_CONTRACT = 'createExistingContract',
  CREATE_INSPECTION_REPORT = 'createInspectionReport',
}

export { UserType, UserTypeEnum, AppRedirect, AppRedirectTargetActions };
